const controls = [
  {
    text: "7",
    value: 7,
    type: "number"
  },
  {
    text: "8",
    value: 8,
    type: "number"
  },
  {
    text: "9",
    value: 9,
    type: "number"
  },
  {
    text: "÷",
    value: "divide",
    type: "operator"
  },
  {
    text: "4",
    value: 4,
    type: "number"
  },
  {
    text: "5",
    value: 5,
    type: "number"
  },
  {
    text: "6",
    value: 6,
    type: "number"
  },
  {
    text: "×",
    value: "multiply",
    type: "operator"
  },
  {
    text: "1",
    value: 1,
    type: "number"
  },
  {
    text: "2",
    value: 2,
    type: "number"
  },
  {
    text: "3",
    value: 3,
    type: "number"
  },
  {
    text: "-",
    value: "subtract",
    type: "operator"
  },
  {
    text: "0",
    value: 0,
    type: "number"
  },
  {
    text: ".",
    value: "decimal",
    type: "decimal"
  },
  {
    text: "=",
    value: "equals",
    type: "equals"
  },
  {
    text: "+",
    value: "add",
    type: "operator"
  }
];

export default controls;
